import React from 'react';
import PropTypes from 'prop-types';
import Button from 'relements/build/esm/ui/button';

import Icon from 'components/Icon';
import { closeComponentModal } from 'actions/BotActions';

import ActionStore from '../ActionStore';
import connection from '../connection';

function getStateFromStores() {
  const modal = ActionStore.getComponentModalStatus();
  return {
    isOpen: modal.active && !modal.isV2,
    isLoading: modal.loading,
    children: modal.children,
    title: modal.title,
    subtitle: modal.subtitle,
    iconType: modal.iconType,
    hasSaveButton: modal.hasSaveButton,
    onIconClick: modal.onIconClick,
    onSave: modal.onSave,
  };
}

@connection([ActionStore], getStateFromStores)
class ComponentModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      disabled: true,
    };
  }

  componentWillReceiveProps(props) {
    const modalState = getStateFromStores(props);

    if (modalState.isOpen) {
      this._openModal();
    } else {
      this._closeModal();
    }
  }

  toggle() {
    closeComponentModal();
  }

  onIconClick = () => {
    if (this.props.onIconClick) {
      this.props.onIconClick();
    } else {
      this.toggle();
    }
  };

  render() {
    if (this.state.disabled) return null;
    const openClassName = this.state.isOpen ? 'open' : '';
    return (
      <div
        className={`component-modal-wrapper ${this.props.className} ${openClassName}`}
      >
        <div className="component-modal-overlay" />
        <div className="component-modal-content">
          <div className="component-modal-header">
            <span
              className="component-modal-header-icon"
              data-testid="modal-header-icon"
              onClick={this.onIconClick}
            >
              {this._renderIcon()}
            </span>
            <div className="component-modal-header-text">
              <span className="title"> 
                {' '}
                {this.props.title}
                {' '}
              </span>
              <span className="subtitle"> 
                {' '}
                {this.props.subtitle}
                {' '}
              </span>
            </div>
            <div className="component-modal-header-button">
              {this.props.headerRight}
              {this._renderSaveButton()}
            </div>
          </div>
          <div className="component-modal-body">{this._renderBody()}</div>
        </div>
      </div>
    );
  }

  _openModal = () => {
    this.setState({ disabled: false }, () => {
      setTimeout(() => this.setState({ isOpen: true }), 0);
    });
  };

  _closeModal = () => {
    this.setState({ isOpen: false });
    setTimeout(() => this.setState({ disabled: true }), 200);
  };

  _renderBody = () => {
    if (this.props.isLoading) {
      return (
        <div className="component-modal-loader">
          <div className="load-icon">
            <h5 className="load-letter"> M </h5>
          </div>
        </div>
      );
    }
    return this.props.children;
  };

  _renderIcon = () => {
    if (this.props.iconType === 'BACK') {
      return <i className="fa fa-angle-left" aria-hidden="true" />;
    }
    if (this.props.iconType === 'CROSS') {
      return <Icon iconType="close" />;
    }
    return <Icon iconType={this.props.iconType} />;
  };

  _renderSaveButton = () => {
    if (!this.props.hasSaveButton) return null;
    const buttonText = this.props.saveButtonText || 'Save & Exit';
    return (
      <Button
        type={Button.TYPES.PRIMARY}
        onClick={this.props.onSave}
        // className="btn theme-blue-background theme-white"
      >
        {buttonText}
      </Button>
    );
  };
}

ComponentModal.propTypes = {
  onSave: PropTypes.func,
  hasSaveButton: PropTypes.bool,
  iconType: PropTypes.string,
  children: PropTypes.element,
  isLoading: PropTypes.bool,
  onIconClick: PropTypes.func,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  saveButtonText: PropTypes.string,
  headerRight: PropTypes.element,
  className: PropTypes.string,
};
export default ComponentModal;
